import mixpanel from 'mixpanel-browser';

export const handleDownload_Windows = () => {
    const link = document.createElement('a');
    link.href = '/Interview%20Cheater-Windows-1.0.0-Setup.exe';
    link.download = 'InterviewCheater-Windows.exe'; // forces a download + custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // ---- SEND TO MIXPANEL ----

    if (process.env.NODE_ENV === 'production') {
        mixpanel.track("Download Windows Complete");
    }

    // ---- END: SEND TO MIXPANEL ----

    return;
};

export const handleDownload_Apple = () => {
    const link = document.createElement('a');
    link.href = '/Interview%20Cheater-Mac-1.0.0-Installer.dmg';
    link.download = 'InterviewCheater-Apple.dmg'; // forces a download + custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // ---- SEND TO MIXPANEL ----

    if (process.env.NODE_ENV === 'production') {
        mixpanel.track("Download Apple Complete");
    }

    // ---- END: SEND TO MIXPANEL ----

    return;
};